import { render, staticRenderFns } from "./default-row.vue?vue&type=template&id=16c1a0da&"
import script from "./default-row.vue?vue&type=script&lang=js&"
export * from "./default-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports